import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actionCards } from '../../actions/cards_actions.jsx';
import { withTranslation, Trans } from 'react-i18next';
import "../../resources/styles.scss";

const emptyCard = {
    cardId: "00000000-0000-0000-0000-000000000000",
    cardNumber: "",
    userName: ""
};

class EditCard extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.item) {
            this.state = { item: this.props.item, isNewCard: false };
        } else {
            this.state = {
                item: Object.assign({}, emptyCard),
                isNewCard: true
            };
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.cancelEditCard = this.cancelEditCard.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        let newState = Object.assign({}, this.state);
        newState.item.cardNumber = this.refs.cardNumber.value;
        newState.item.cardNumberInternal = this.refs.cardNumberInternal.value;
        newState.item.userName = this.refs.userName.value;
        newState.item.car = this.refs.car.value;
        newState.item.description = this.refs.description.value;
        this.setState(newState);

        if (this.state.isNewCard) {
            this.props.addCard(newState.item);
        } else {
            this.props.editCard(newState.item);
        }
    }

    cancelEditCard(e) {
        e.preventDefault();
        this.props.history.goBack();
    }

    render() {
        return (
            <div className="form_container">
                <form className="edit-card-form" onSubmit={this.handleSubmit}>
                    <div className="form-body">
                        <p>
                            <label><Trans>Cards.cardNumberExternal</Trans></label>
                            <input type="text" ref="cardNumber" defaultValue={this.state.item.cardNumber}/>
                        </p>
                        <p>
                            <label><Trans>Cards.cardNumber</Trans></label>
                            <input type="text" ref="cardNumberInternal" defaultValue={this.state.item.cardNumberInternal} />
                        </p>
                        <p>
                            <label><Trans>Cards.userName</Trans></label>
                            <input type="text" ref="userName" defaultValue={this.state.item.userName}/>
                        </p>
                        <p>
                            <label><Trans>Cards.car</Trans></label>
                            <input type="text" ref="car" defaultValue={this.state.item.car} />
                        </p>
                        <p>
                            <label><Trans>Cards.description</Trans></label>
                            <input type="text" ref="description" defaultValue={this.state.item.description} />
                        </p>
                        <div className="form-buttons-container">
                            <button type="submit"><Trans>Table.saveButton</Trans></button>
                            <button onClick={this.cancelEditCard}><Trans>Table.cancelButton</Trans></button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let id = ownProps.match.params.id;
    return {
        item: id ? state.cards.cards.find(x => x.cardId === id) : null
    };
}

const mapDispatch = (dispatch, ownProps) => {
    return {
        editCard: card => dispatch(actionCards.editCard(card, ownProps)),
        addCard: card => dispatch(actionCards.addCard(card, ownProps))
    };
};


export default withRouter(connect(mapStateToProps, mapDispatch)(withTranslation("translations")(EditCard)));